module.exports = __webpack_public_path__ + "static/img/WSJJ.5bb58e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/WSJJ.png
// module id = o7v1
// module chunks = 1